module.exports = __webpack_public_path__ + "img/loading.3e562346.gif";